import { domainExtensionBlacklist, emailValidWithOnlyComDomainList } from '@/constants/base'
import { DAYS, MONTHS } from '@/constants/Srp'
import {getCookie} from "@/utils/general/cookie";
import { getIndianTime } from '../general/date';
import { SALE_CONFIG } from '@/constants/Sale';
import useVisibilityWithinTimeRange from "@/hooks/srp/useVisibilityWithinTimeRange";
import { BLACK_FRIDAY_SALE_CONFIG } from '@/constants/Sale'
import { isServer } from '@/utils/general'
import { UTM_PAID, UTM_SEO, UTM_META, UTM_DIRECT, utmMetaSources, UTM_PARAMS_SESSION_KEY } from '@/constants/components/common'
import { isEmpty } from '@/utils/general/browserHelper'
import { utmParamManager } from '@cleartrip/ct-platform-utils'

export const deepEqual: (x: any, y: any) => boolean = (x, y) => {
    const ok = Object.keys,
        tx = typeof x,
        ty = typeof y
    return x && y && tx === 'object' && tx === ty
        ? ok(x).length === ok(y).length && ok(x).every(key => deepEqual(x[key], y[key]))
        : x === y
}

export const typeOf = (obj: any) => {
    let detv: any = typeof obj
    const isObject = (value: any) => value === 'object'
    const isArray = (value: any) => Object.prototype.toString.call(value) === '[object Array]'

    if (isObject(detv)) {
        if (obj) {
            if (isArray(obj)) {
                detv = 'array'
            }
        } else {
            detv = 'null'
        }
    }
    return detv
}

export const pad = (s: number) => {
    return s < 10 ? `0${s}` : s
}

export const formatDate = (date: any) => {
    const type = typeOf(date)
    let nDate
    if (type === 'number') {
        nDate = new Date(date)
    } else if (type === 'string') {
        nDate = new Date(parseInt(date, 10))
    } else {
        nDate = date
    }
    return `${DAYS[nDate.getDay()]}, ${pad(nDate.getDate())} ${MONTHS[nDate.getMonth()]}`
}

export const transformTimeStamp = (timeStamp: string) => {
    const dateString = new Date(Number(timeStamp)).toString()
    const [day, month, date, year, time] = dateString?.split(' ')
    const [hours, minutes, seconds] = time.split(':')
    return `${date} ${month}, ${hours}:${minutes}`
}

export const isFFFlowEnabled = () =>{
    const ffCookie = getCookie('ffEnabled')
    return ffCookie === 'true'
}

/**
 * Generates an error message if the email's domain extension is blacklisted.
 *
 * @param email - The email address to validate.
 * @returns A string containing an error message suggesting a correction if the domain extension is blacklisted,
 *          or an empty string if the email is valid.
 */
export const getDomainExtErrMsg = (email: string) => {
    
    const emailParts= email.split("@")
     const domainPart= emailParts[1] 
     const emailSplit= domainPart.split(".")
     if (emailValidWithOnlyComDomainList.includes(emailSplit[0].toLowerCase())){
        if(emailSplit.length===2 && emailSplit[1].toLowerCase()==="com"){
            return ""
        }
        else{
            return "Please enter a valid email address"
        }
     }
     
    const domainExtension = emailSplit[emailSplit.length - 1].toLowerCase()
    const isInvalidDomain = domainExtensionBlacklist.includes(domainExtension)
    return isInvalidDomain ? "Please enter a valid email address" : ""
}
export function isWithinTimeRange(fromTime:string, toTime:string) {
    const startTime = new Date(fromTime);
    const endTime = new Date(toTime);
    const currentTime = getIndianTime();
    return currentTime >= startTime && currentTime <= endTime;
  }
export const isTravelMaxSale = () => {
    return isWithinTimeRange(   SALE_CONFIG.START_TIME, SALE_CONFIG.END_TIME);
}

export const BlackFridaySaleTimeRange = () => {
    return useVisibilityWithinTimeRange(BLACK_FRIDAY_SALE_CONFIG.START_TIME,BLACK_FRIDAY_SALE_CONFIG.END_TIME)
}

export const parseFilters = (filters, isFilterV2: boolean = false) => {
    const filtersOW = isFilterV2 ? filters.onwardLeg! : filters
    const filtersRT = filters?.returnLeg || {}
    const filtersCommon = filters
  
    return { filtersOW, filtersRT, filtersCommon }
}

export const checkIsFilterV2 = (selectedFilters) => {
    return !!selectedFilters?.onwardLeg
}

export const FARE_INCLUSIONS = Object.freeze({
    BAGGAGE: 'withBaggage',
})

export const isCheckInBaggageEnabled = (selectedFilters) => {
    const isFilterV2 = checkIsFilterV2(selectedFilters)
    const { filtersOW, filtersRT } = parseFilters(selectedFilters, isFilterV2)
    const { fareInclusions: { selectedValues: fareInclusionsOW = [] } = {} } = filtersOW || {}
    const { fareInclusions: { selectedValues: fareInclusionsRT = [] } = {} } = filtersRT || {}
    return {
        ow: fareInclusionsOW.includes(FARE_INCLUSIONS.BAGGAGE),
        rt: fareInclusionsRT.includes(FARE_INCLUSIONS.BAGGAGE)
    }
}


export const getUtmSourceInfo = () => {
  const utmData = { trafficSource: 'DIRECT', utmCustom: '' }
  if (isServer()) {
    return utmData
  }
  try {
    const params = utmParamManager.getSpecificParamsFromURL(['traffic_source', 'utm_custom'])
    const existingUtmData = utmParamManager.getStoredParams()
    if (!isEmpty(existingUtmData)) {
      utmData.utmCustom = existingUtmData.utm_custom || ''
      utmData.trafficSource = existingUtmData.traffic_source || ''
    } else {
      utmData.utmCustom = params.utm_custom || ''
      utmData.trafficSource = params.traffic_source || ''
    }
    return utmData
  } catch (e) {
    console.error(e)
    return utmData
  }
}
